import(/* webpackMode: "eager" */ "/app/src/app/ourWork/layout.js");
